const inprogressSubtleLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11.25" stroke-width="1.5"/><polyline stroke-width="1.5" points="12 5 12 12 19 12"/></svg>',
};

export { inprogressSubtleLarge as default };
